var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.885,
    height: 51.108,
    viewBox: "0 0 66.885 51.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 66.885,
    height: 51.108,
    fill: "#0c9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10267",
    "data-name": "Group 10267",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9523",
    "data-name": "Group 9523",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33579",
    "data-name": "Path 33579",
    d: "M22.556,0,25.9,4.837c-8.291,4.636-14.3,10.982-15.75,20.906l2.415-.734a11.527,11.527,0,0,1,4.969-.152A13.862,13.862,0,0,1,23.906,27.3a12.364,12.364,0,0,1,5.124,8.044,13.875,13.875,0,0,1-2.91,11.317,11.065,11.065,0,0,1-7.572,4.261,14,14,0,0,1-12.54-4A18.678,18.678,0,0,1,.525,36.191a39.642,39.642,0,0,1-.508-6.82A27.637,27.637,0,0,1,2.662,18.854,35.751,35.751,0,0,1,11.228,7.34,41.716,41.716,0,0,1,22.556,0",
    transform: "translate(37.614 0)",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33580",
    "data-name": "Path 33580",
    d: "M25.931,4.623C17.546,9.258,11.576,15.672,10.2,25.614a11.969,11.969,0,0,1,6.44-1.06,16.305,16.305,0,0,1,6,1.743,12.193,12.193,0,0,1,6.3,8.14,13.466,13.466,0,0,1-2.8,11.923A11.37,11.37,0,0,1,18.5,50.686,13.967,13.967,0,0,1,5.6,46.223,20.444,20.444,0,0,1,.559,36.285,28.17,28.17,0,0,1,.11,28.142,29.092,29.092,0,0,1,3.271,17.421,36.94,36.94,0,0,1,11.777,6.668,41.713,41.713,0,0,1,21.194.385a3.442,3.442,0,0,1,.935-.372c.244-.04.642,0,.756.164,1.043,1.464,2.038,2.961,3.046,4.445",
    transform: "translate(0 0.228)",
    fill: "#0c9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.0186e496cc2179f1c44c3919854c0e7e.svg";
export { ForwardRef as ReactComponent };